/**
 * Sign-up entry (#174): the free page and call to action a registration started from.
 *
 * Register links on the landing site carry ?from=<page>:<location> (home:hero,
 * content:/izvestiya/firma/). An email sign-up sends it in the sign-up metadata
 * (billing.on_auth_user_created records it); Google can't carry metadata, so the entry
 * survives the redirect in sessionStorage and /auth/callback records it
 * (record_signup_entry). Same format as billing.sanitize_signup_entry.
 */

const ENTRY_PATTERN = /^[a-z0-9_-]{1,40}:[a-z0-9_/.-]{1,59}$/

const OAUTH_SIGNUP_ENTRY_KEY = 'lexalert.oauthSignupEntry'

/** The Sign-up entry of a register link's query string, if well formed */
export function parseSignupEntry(search: string): string | null {
  const entry = new URLSearchParams(search).get('from')?.trim()
  return entry && ENTRY_PATTERN.test(entry) ? entry : null
}

/** Keep the entry for /auth/callback (null clears an earlier one) */
export function stashOAuthSignupEntry(entry: string | null | undefined): void {
  try {
    if (entry) sessionStorage.setItem(OAUTH_SIGNUP_ENTRY_KEY, entry)
    else sessionStorage.removeItem(OAUTH_SIGNUP_ENTRY_KEY)
  } catch {
    // storage unavailable: attribution is best effort
  }
}

/** The entry kept before the Google redirect, removed once read */
export function takeOAuthSignupEntry(): string | null {
  try {
    const entry = sessionStorage.getItem(OAUTH_SIGNUP_ENTRY_KEY)
    sessionStorage.removeItem(OAUTH_SIGNUP_ENTRY_KEY)
    return entry
  } catch {
    return null
  }
}
